import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

const StyledButton = styled(Button)(({ theme }) => ({
  width: "90%",
  fontWeight: "bold",
  padding: "8px",
  borderRadius: "27px",
  height: "54px",
  background: "transparent",
  textTransform: "none",
  "&:hover": {
    opacity: 0.9, // ホバー時の軽いエフェクト
  },
  ...theme.components.button,
}));

export default StyledButton;
